core.factory('responseInterceptor', [ '$q',
    function ($q) {
        return {
            response: function (response) {
                var result = new HttpResponseVO(response.data, response.status, response.headers, response.config);
                return result;
            },
            responseError: function(rejection) {
                var result = new HttpResponseVO(rejection.data, rejection.status, rejection.headers, rejection.config);
                return $q.reject(result);
            }
        };
    }
]);
